import React from 'react';
import {
  Modal,
  View,
  TouchableWithoutFeedback,
  Linking,
} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {useRemoteConfig} from '../../../../context/useRemoteConfig';
import {
  Description,
  HowItWorksTitle,
  TableContainer,
  TableHeader,
  TableHeaderText,
  TableRow,
  TableRowText,
  Container,
  ModalOverlay,
  ModalContent,
  Header,
  HeaderTitle,
  CloseButton,
  CloseButtonText,
  List,
} from './styles';
import {Titles} from '../../../../components/Interface/Typographies/Titles';
import {StepList} from '../../../../components/Interface/List/StepList';
import {Button} from '../../../../components/Interface/Forms/Buttons/Button';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function InfluencerBottomSheet({isOpen, onClose}: Props) {
  const {influencerTableData, isLoading, numeroSuporteInfluenciador} = useRemoteConfig(isOpen);
  const link = `https://wa.me/${numeroSuporteInfluenciador}?text=Oi!%20Quero%20saber%20como%20funciona%20o%20Influencer%20Barat%C3%A3o`
  const handlePress = () => {
    Linking.openURL(
      link,
    );
  };

  return (
    <Modal visible={isOpen} onRequestClose={onClose} transparent animationType="fade">
      <ModalOverlay>
        <TouchableWithoutFeedback onPress={onClose}>
          <View
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
          />
        </TouchableWithoutFeedback>
        <ModalContent>
          <SafeAreaView style={{flex: 1}}>
            <Header>
              <HeaderTitle>Influenciador</HeaderTitle>
              <CloseButton onPress={onClose}>
                <CloseButtonText>✕</CloseButtonText>
              </CloseButton>
            </Header>
            <Container>
              <Titles
                title="Seu post vale gasolina!"
                subtitle="Você faz stories, a gente abastece!"
              />
              <Description>
                Qualquer pessoa pode ser influencer no Baratão! Nossa campanha é
                uma troca justa: você publica nos Stories sobre os benefícios do
                aplicativo Baratão Combustíveis e ganha litros de combustível.
              </Description>

              <HowItWorksTitle>Como funciona?</HowItWorksTitle>

              <List>
                <StepList
                  number={1}
                  text="Faça stories marcando @barataocombustiveis"
                />
                <StepList
                  number={2}
                  text="O conteúdo precisa seguir a proposta da marca"
                />
                <StepList
                  number={3}
                  text="O número de litros que você ganha depende da sua quantidade de seguidores, ou seja, quanto mais gente te acompanha, mais você abastece. O máximo são 2 posts."
                />
              </List>

              <TableContainer>
                <TableHeader>
                  <TableHeaderText>Seguidores</TableHeaderText>
                  <TableHeaderText>Litros por post</TableHeaderText>
                </TableHeader>

                {!isLoading &&
                  influencerTableData.map((item, index) => (
                    <TableRow key={index}>
                      <TableRowText>{item.followers}</TableRowText>
                      <TableRowText>{item.liters}</TableRowText>
                    </TableRow>
                  ))}
              </TableContainer>

              <View style={{paddingBottom: 20}} />

              <Button
                title="Quero ser influenciador"
                onPress={handlePress}
                enabled
              />

              <View style={{paddingBottom: 40}} />
            </Container>
          </SafeAreaView>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
}
